import { HallowAnalyticsEvent } from "@packages/analytics";
import { Link } from "@packages/framework";
import type { TheWordSectionItem } from "@packages/sdk";
import { differenceInHours } from "date-fns/differenceInHours";

import type { CSSColorStrict } from "../../../../../utils/colors/types/CSSColorStrict.types";
import { Button } from "../../../_core/Button/Button.emotion";
import type { TheWordLargeProps } from "../../the-word/TheWordLarge.emotion";
import type { BaseGetSectionItemProps } from "./Section.emotion";

export type GetSectionItemTheWordPropsProps =
  BaseGetSectionItemProps<TheWordSectionItem>;
export const getSectionItemTheWordProps = ({
  item,
  link,
  t,
  analytics,
}: GetSectionItemTheWordPropsProps): TheWordLargeProps => {
  const gameFinished = item?.reference?.game?.state === "FINISHED";
  const gameUnstarted = item?.reference?.game?.state === "UNSTARTED";

  const actions = link
    ? [
        <Button
          asChild
          key="links"
          variant="white"
          onClick={() =>
            analytics.track({
              event: gameUnstarted
                ? HallowAnalyticsEvent.TappedStartTheWord
                : gameFinished
                  ? HallowAnalyticsEvent.TappedTheWordSummary
                  : HallowAnalyticsEvent.TappedResumeTheWord,
              properties: {
                game_id: item?.reference?.game?.id,
                word: item?.reference?.game?.word,
                word_id: item?.reference?.game?.id,
              },
            })
          }
        >
          <Link href={"/the-word"}>
            {t(
              gameUnstarted
                ? "the_word_play_cta"
                : gameFinished
                  ? "web_review_trivia"
                  : "resume_trivia",
            )}
          </Link>
        </Button>,
      ]
    : null;

  const tags = item?.reference?.game
    ? [
        t("x_playing_plural", {
          x_playing_plural: item.reference.game.player_count,
        }),
        t("ends_in_hours", {
          ends_in_hours: differenceInHours(
            new Date(item.reference.game.ends_at),
            new Date(),
          ),
        }),
      ]
    : null;

  return {
    actions,
    centerActions: actions,
    color: item?.reference?.game?.images?.color_hex as CSSColorStrict,
    imgSrc: item?.reference?.game?.images,
    summary: gameFinished ? item?.reference?.game?.summary : null,
    tags,
  };
};
